__turbopack_context__.v({
  "outOfStockAlert": "ProductNotInStockSection-module-scss-module__kjzlHa__outOfStockAlert",
  "outOfStockButton": "ProductNotInStockSection-module-scss-module__kjzlHa__outOfStockButton",
  "stockMessage": "ProductNotInStockSection-module-scss-module__kjzlHa__stockMessage",
});
